export default __webpack_public_path__ + "static/media/tyterp.eaa7f05f.png";